<i 
    [ngClass]="{'fa-beat': active}"
    class="fa-duotone fa-scanner-gun fa-lg "></i>
